import React from 'react';
import { Atom, Twitter, Linkedin, Github } from 'lucide-react';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-slate-900 text-slate-300 py-12 border-t border-slate-800" data-id="element-134">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-135">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-136">
          <div className="col-span-1 md:col-span-2" data-id="element-137">
            <div className="flex items-center space-x-2 text-white font-bold text-xl tracking-tight mb-4" data-id="element-138">
              <Atom className="h-6 w-6 text-indigo-500" data-id="element-139" />
              <span data-id="element-140">Atomic Team Design</span>
            </div>
            <p className="text-slate-400 max-w-xs leading-relaxed" data-id="element-141">
              Science-inspired organisational design for modern engineering
              teams. Build structure that scales.
            </p>
          </div>

          <div data-id="element-142">
            <h4 className="text-white font-semibold mb-4" data-id="element-143">Resources</h4>
            <ul className="space-y-2" data-id="element-144">
              <li data-id="element-145">
                <button onClick={() => scrollToSection('concepts')} className="hover:text-white transition-colors" data-id="element-146">
                  Concepts
                </button>
              </li>
              <li data-id="element-147">
                <button onClick={() => scrollToSection('manifesto')} className="hover:text-white transition-colors" data-id="element-148">
                  Manifesto
                </button>
              </li>
              <li data-id="element-149">
                <button onClick={() => scrollToSection('getting-started')} className="hover:text-white transition-colors" data-id="element-150">
                  Getting Started
                </button>
              </li>
              <li data-id="element-151">
                <button onClick={() => scrollToSection('platform')} className="hover:text-white transition-colors" data-id="element-152">
                  Platform
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-153">
            <h4 className="text-white font-semibold mb-4" data-id="element-154">Connect</h4>
            <div className="flex space-x-4" data-id="element-155">
              <a href="#" className="hover:text-white transition-colors" aria-label="Twitter" data-id="element-156">
                <Twitter className="h-5 w-5" data-id="element-157" />
              </a>
              <a href="#" className="hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-158">
                <Linkedin className="h-5 w-5" data-id="element-159" />
              </a>
              <a href="#" className="hover:text-white transition-colors" aria-label="GitHub" data-id="element-160">
                <Github className="h-5 w-5" data-id="element-161" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500" data-id="element-162">
          <p data-id="element-163">© 2026 Atomic Team Design. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-164">
            <a href="#" className="hover:text-slate-300" data-id="element-165">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-slate-300" data-id="element-166">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}